<div class="card padded">
  <h4 *ngIf="tileInstance.heading">{{ tileInstance.heading }}</h4>
  <p *ngIf="tileInstance.text">{{ tileInstance.text }}</p>
</div>
